import React, { useState, useEffect } from "react";
import "./dashboard.css";
import { Typography, Table, Tooltip, message  } from "antd";
import {InfoCircleOutlined, CopyOutlined} from "@ant-design/icons";
import * as zoneActions from "../../redux/actions/zone.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Pageloader from "../../components/loader";
import TableCaret from "../../components/tableCaret/tableCaret";
import moment from "moment";

const { Title, Text } = Typography;
var _ = require('lodash');
const getpageloadtime= moment().format("hh:mm A");

const DashBoard = (props) => {
  const pagename = "Dashboard";
  const [loading, setLoading] = useState(true);
  const [sortedData, setSortedData] = useState([]);

  useEffect(() => {
    props.zoneActions.getZoneListAction();
  }, []);
  useEffect(() => {
    if(props.dashboardData){
      if(Object.values(props.dashboardData).length>0) setLoading(false);
      else setLoading(true);
      setSortedData(_.orderBy(Object.values(props.dashboardData), ['unassigned_orders', 'store_name_local'], ['desc', 'asc']));
    }
  }, [props.dashboardData]);
  useEffect(() => {
    if(props.zoneData.length>0){
      props.zoneData.map((store) => {
        props.zoneActions.getDashboardListAction(store.storeId, store.zoneName);
      })

    }
  }, [props.zoneData]);

  const [sc, setsc] = useState({
    value:  "",
    sort:  'desc',
  })
  const sorting = (value) => {
    if (value && value === sc.value){
      if (sc.sort === 'desc'){
        setSortedData(_.orderBy(Object.values(props.dashboardData), [value], ['asc']));
        setsc({ value:  value, sort:  'asc' })
      }else {
        setSortedData(_.orderBy(Object.values(props.dashboardData), [value], ['desc']));
        setsc({ value:  value, sort:  'desc' })
      }
    } else {
      setSortedData(_.orderBy(Object.values(props.dashboardData), [value], ['desc']));
      setsc({ value:  value, sort:  'desc' })
    }
  }

  const [messageApi, contextHolder] = message.useMessage();
  const copyData = (value) => {
    // const copytext = `${value.store_name_local} closed for\nPlanned Riders:\nRiders Picked Shifts (Scheduled): ${value.planned_riders}\nActive riders: ${value.active_riders}\nFree riders at branch: ${value.free_rider_at_mart}\nFree Riders Returning to Branch: ${value.free_returning_rider}\nBusy Riders - at branch waiting for order: ${value.assigned_riders}\nBusy riders - on route: ${value.in_progress_riders}\nRiders on Break: ${value.break_riders}\nOrders not packed: ${value.orders_not_packed}\nUnassigned orders: ${value.unassigned_orders}\nAccepted orders but not on route: ${value.assigned_orders}\nLongest Pickup Pending Order Time: ${value.longestPendingOrder != 0 ? Math.round(value.longestPendingOrder.order_duration) : 0} min\nTime Stamp: ${getpageloadtime}`

    const copytext = `${value.store_name_local} closed for\nPlanned Riders:\nRiders Picked Shifts (Scheduled): ${value.planned_riders}\nActive riders: ${value.active_riders}\nFree riders: ${value.free_riders}\nBusy Riders: ${value.busy_riders}\nRiders on Break: ${value.break_riders}\nUnassigned orders: ${value.unassigned_orders}\nAccepted orders but not on route: ${value.assigned_orders}\nLongest Pickup Pending Order Time: ${value.longestPendingOrder != 0 ? Math.round(value.longestPendingOrder.order_duration) : 0} min\nTime Stamp: ${getpageloadtime}`

    navigator.clipboard.writeText(copytext);
    messageApi.open({
      type: 'success',
      content: `Copied Text ${value.store_name_local}`,
    });
  }

  const columns = [
    {
      title: ()=><div onClick={()=>sorting("store_name_local")}>
        Mart
        <TableCaret value={"store_name_local"} sort={sc}/>
      </div>,
      dataIndex: 'store_name_local',
      render: (value) => (value||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("longestPendingOrder.order_duration")}>
        Longest Pickup Pending Order Time
        <Tooltip title="Current Time - (minus) Created at Time for orders not on-route"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"longestPendingOrder.order_duration"} sort={sc}/>
      </div>,
      dataIndex: 'longestPendingOrder',
      render: (value) => (value?.order_duration != 0 && value != 0 ? 
        <Text type={ Math.round(value?.order_duration) > 15?"danger":"success"}>{Math.round(value?.order_duration)+" min"}</Text>
      : "-")
    },
    {
      title: ()=><div onClick={()=>sorting("planned_riders")}>
        Riders Picked Shifts (Scheduled)
        <Tooltip title="Riders who have picked shifts during current time"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"planned_riders"} sort={sc}/>
      </div>,
      dataIndex: 'planned_riders',
      render: (value) => (value||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("active_riders")}>
        Active riders
        <Tooltip title="Riders who are in current shift and have started the shift"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"active_riders"} sort={sc}/>
      </div>,
      dataIndex: 'active_riders',
      render: (value) => (value||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("free_riders")}>
        Free riders
        <Tooltip title="Riders who are in current shift, have started the shift and have no orders in Picked Up"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"free_riders"} sort={sc}/>
      </div>,
      dataIndex: 'free_riders',
      render: (value) => (value||"-"),
    },
    // {
    //   title: ()=><div onClick={()=>sorting("free_rider_at_mart")}>
    //     Free riders at branch
    //     <Tooltip title="Riders who currently have shift started, are present at branch and have no orders in Picked Up"><InfoCircleOutlined /></Tooltip>
    //     <TableCaret value={"free_rider_at_mart"} sort={sc}/>
    //   </div>,
    //   dataIndex: 'free_rider_at_mart',
    //   render: (value) => (value||"-"),
    // },
    // {
    //   title: ()=><div onClick={()=>sorting("free_returning_rider")}>
    //     Free Riders Returning to Branch
    //     <Tooltip title="Riders who currently have shift started, are returning to branch and have no orders in Picked Up"><InfoCircleOutlined /></Tooltip>
    //     <TableCaret value={"free_returning_rider"} sort={sc}/>
    //   </div>,
    //   dataIndex: 'free_returning_rider',
    //   render: (value) => (value||"-"),
    // },
    {
      title: ()=><div onClick={()=>sorting("busy_riders")}>
        Busy riders
        <Tooltip title="Riders who are in current shift, have started the shift and have orders in Picked Up"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"busy_riders"} sort={sc}/>
      </div>,
      dataIndex: 'busy_riders',
      render: (value) => (value||"-"),
    },
    // {
    //   title: ()=><div onClick={()=>sorting("assigned_riders")}>
    //     Busy Riders - at branch waiting for order
    //     <Tooltip title="Busy rider but drop off not started"><InfoCircleOutlined /></Tooltip>
    //     <TableCaret value={"assigned_riders"} sort={sc}/>
    //   </div>,
    //   dataIndex: 'assigned_riders',
    //   render: (value) => (value||"-"),
    // },
    // {
    //   title: ()=><div onClick={()=>sorting("in_progress_riders")}>
    //     Busy riders - on route
    //     <Tooltip title="Busy rider, drop off has started"><InfoCircleOutlined /></Tooltip>
    //     <TableCaret value={"in_progress_riders"} sort={sc}/>
    //   </div>,
    //   dataIndex: 'in_progress_riders',
    //   render: (value) => (value||"-"),
    // },
    {
      title: ()=><div onClick={()=>sorting("break_riders")}>
        Riders on Break
        <Tooltip title="Riders who are in current shift, have started the shift and are on break"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"break_riders"} sort={sc}/>
      </div>,
      dataIndex: 'break_riders',
      render: (value) => (value||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("total_orders")}>
        Total orders
        <Tooltip title="Total Orders - Delivered - Cancelled"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"total_orders"} sort={sc}/>
      </div>,
      dataIndex: 'total_orders',
      render: (value) => (value||"-"),
    },
    // {
    //   title: ()=><div onClick={()=>sorting("orders_not_packed")}>
    //     Orders not packed
    //     <Tooltip title="Orders not packed"><InfoCircleOutlined /></Tooltip>
    //     <TableCaret value={"orders_not_packed"} sort={sc}/>
    //   </div>,
    //   dataIndex: 'orders_not_packed',
    //   render: (value) => (value||"-"),
    // },
    {
      title: ()=><div onClick={()=>sorting("unassigned_orders")}>
        Unassigned orders
        <Tooltip title="Orders not accepted by any rider"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"unassigned_orders"} sort={sc}/>
      </div>,
      dataIndex: 'unassigned_orders',
      render: (value) => (value||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("assigned_orders")}>
        Accepted orders
        <Tooltip title="Orders accepted by riders + Pickup Started + Pickup Reached + Pickup Successful"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"assigned_orders"} sort={sc}/>
      </div>,
      dataIndex: 'assigned_orders',
      render: (value) => (value||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("on_route_orders")}>
        On route orders
        <Tooltip title="Drop off Started + Drop off Reached"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"on_route_orders"} sort={sc}/>
      </div>,
      dataIndex: 'on_route_orders',
      render: (value) => (value||"-"),
    },
    // {
    //   title: ()=><div onClick={()=>sorting("cancelled_orders")}>
    //     Cancelled Orders
    //     <TableCaret value={"cancelled_orders"} sort={sc}/>
    //   </div>,
    //   dataIndex: 'cancelled_orders',
    //   render: (value) => (value||"-"),
    // },
    // {
    //   title: ()=><div onClick={()=>sorting("completed_orders")}>
    //     Completed Orders
    //     <TableCaret value={"completed_orders"} sort={sc}/>
    //   </div>,
    //   dataIndex: 'completed_orders',
    //   render: (value) => (value||"-"),
    // },
    {
      title: "Copy Text",
      render: (value) => (<a onClick={()=>copyData(value)}><CopyOutlined /></a>),
    },
  ]

  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>{pagename}</Title>
        </div>
        <div className="pch">{contextHolder}</div>
      </div>
      <div className="p-content">
        {loading == true ? 
          <Pageloader />
          :
          <Table
            // className="table-ws table-tcenter not-first-child"
            dataSource={sortedData}
            columns={columns}
            pagination={false}
          />
        }
      </div>
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    dashboardFilter: state.ZoneReducer.dashboardFilter,
    dashboardData: state.ZoneReducer.dashboardData,
    zoneData: state.ZoneReducer.zoneData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashBoard);